export const SET_BASE_CONFIG = 'SET_BASE_CONFIG';

export const SET_TABINDEX = 'SET_TABINDEX';

export const FETCH_COMMITS = 'FETCH_COMMITS';
export const SET_COMMITS = 'SET_COMMITS';
export const SET_COMMITS_SILENT = 'SET_COMMITS_SILENT';
export const FETCH_COMMITS_ERROR = 'FETCH_COMMITS_ERROR';

export const FETCH_CONTEXT_COMMITS = 'FETCH_CONTEXT_COMMITS';
export const SET_CONTEXT_COMMITS = 'SET_CONTEXT_COMMITS';
export const FETCH_CONTEXT_COMMITS_ERROR = 'FETCH_CONTEXT_COMMITS_ERROR';

export const SET_SELECTED_COMMITS = 'SET_SELECTED_COMMITS';

export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';

export const SET_TO_REMOVE_COMMITS = 'SET_TO_REMOVE_COMMITS';

export const RESET_MODAL_STATE = 'RESET_MODAL_STATE';
